import { Grid } from '@mui/material';
import { Stack } from '@mui/system';
import { IPatientInfo } from 'apis/admin/type';
import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import SectionTitle from '../components/SectionTitle';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
  patientInfo: IPatientInfo;
}

const checks_situation = [
  {
    label: 'HBs Ag',
    key: 'infection_state.checked1',
  },
  {
    label: 'Anti-HCV',
    key: 'infection_state.checked2',
  },
  {
    label: 'Anti-HIV',
    key: 'infection_state.checked3',
  },
  {
    label: 'VDRL',
    key: 'infection_state.checked4',
  },
  {
    label: '모름',
    key: 'infection_state.checked5',
  },
  {
    label: '기타',
    key: 'infection_state.checked6',
  },
];

const Source = (props: Props) => {
  const { disabled, watch, setValue, getValues, patientInfo, register } = props;

  const rows = [
    { title: '환자등록번호', variable: 'info_name' },
    { title: '환자명', variable: 'info_no' },
    { title: '진료과', variable: 'info_contact' },
    { title: '진단명', variable: 'info_date' },
  ];

  return (
    <>
      <SectionTitle title="3. 감염원(환자)의 상태" mb={3} mt={3} />

      <RowContainer xs={12}>
        {rows.map(({ title, variable }, i) => (
          <RowContent
            key={variable}
            title={title}
            titleRatio={1}
            childrenRatio={2}
          >
            <Form.MuiTextField
              disabled={disabled}
              value={
                i === 0
                  ? patientInfo.patient_virtual_id || patientInfo.patient_id
                  : i === 1
                  ? patientInfo.name
                  : i === 2
                  ? patientInfo.department
                  : patientInfo.disease_main.disease_kor
              }
              InputProps={{ readOnly: true }}
              sx={{ backgroundColor: 'lightgray' }}
            />
          </RowContent>
        ))}
        <RowContent title="감염상태" titleRatio={1} childrenRatio={11}>
          <Stack direction="row">
            {checks_situation.map((v, i) => {
              return (
                <Grid item xs={i === 5 ? 0.6 : 1.8}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
            <Form.MuiTextField
              required={false}
              sx={{ width: '120px' }}
              disabled={disabled}
              placeholder="직접 입력"
              {...register(`infection_state_input`)}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </>
  );
};

export default Source;
